import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import Link from "@/Layouts/Link";
import '@/Pages/Collections/scss/ocean.scss';

class OceanMobile extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <>
            <div className={`oceanPanelMobile`}>
                <div className={`oceanPanelMobile__one`}>
                    <div className={`contentMobile`}>
                        <h1 className={`h1 h1__oceanMobile`}>ОКЕАН</h1>
                        <Link href={`/catalog/okean`}
                              className={`btn btn__oceanMobile`}
                        >
                            Коллекция серебряных украшений
                        </Link>
                        <p className={`inOceanMobile`}>Погрузиться в океан</p>
                        <img className={`arrow-bottom-mobile`}
                             src={`/storage/img/collections/cosmos/arrow-2.png`}
                             alt={`Погрузиться в океан`}
                             title={`Погрузиться в океан`}
                        />
                    </div>
                </div>
                <div className={`oceanPanelMobile__two`}>
                    <div className={`contentMobile`}>
                        <img className={`medusaLeftMobile`}
                             src={`/storage/img/collections/ocean/medusaLeft.png`}
                             alt={`image`}
                             title={`image`}
                        />
                        <p className={`textTopMobile`}>
                            Вот&nbsp;бы &laquo;пляжное&raquo; настроение оставалось с&nbsp;нами как можно дольше!
                            Чтобы яркое солнце, чистое небо и&nbsp;берег океана всегда были рядом...
                        </p>
                        <Link href={`/catalog/product/04-0255-00-203-0200-69`}
                              className={`medusaCenterMobile`}>
                            <img src={`/storage/img/collections/ocean/medusaCenter.png`}
                                 alt={`image`}
                                 title={`image`}
                            />
                        </Link>
                        <p className={`text`}>
                            Вдохновляясь этой смелой романтичной мечтой, бренд PLATINA создал коллекцию украшений,
                            которая наполнит вашу жизнь позитивом. Независимо от&nbsp;капризов погоды
                            и&nbsp;даты на&nbsp;календаре!
                            <br />
                            Наш ОКЕАН&nbsp;&mdash; это богатство и&nbsp;великолепие подводной фауны в&nbsp;ярких
                            анималистичных образах. Готовы погрузиться в&nbsp;него прямо сейчас?
                        </p>
                    </div>
                </div>
                <div className={`oceanPanelMobile__three`}>
                    <div className={`contentMobile`}>
                        <p className={`text`}>
                            Краски океана&nbsp;&mdash; роскошь, созданная Природой! Очарованные их&nbsp;изяществом,
                            украшенные жемчужной &laquo;пеной&raquo;, наши рыбки играют оттенками эмалей, обещая
                            восторг новых открытий.
                        </p>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-3.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-2.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__three`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-4.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__four`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-5.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__five`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-6.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <Link href={`/catalog/product/03-3260-00-301-0200-68`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/03-3260-00-301-0200-68_new.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/04-0257-00-301-0200-68`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/04-0257-00-301-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4769-00-301-0200-68`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/02-4769-00-301-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/01-5488-00-301-0200-68`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/01-5488-00-301-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0677-00-301-0200-68`}>
                            <img className={`fish fish__five`}
                                 src={`/storage/img/collections/ocean/mobile/05-0677-00-301-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__four`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-7.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-8.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__three`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-9.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            В&nbsp;центре внимания яркие &laquo;солнышки&raquo; на&nbsp;глубине моря! Серебряные
                            морские звезды... Стильный талисман для тех, кто в&nbsp;тайне мечтает
                            об&nbsp;исполнении
                            желаний.
                        </p>
                        <Link href={`/catalog/product/01-5476-00-203-0200-68`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/01-5476-00-203-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4757-00-203-0200-68`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/02-4757-00-203-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/03-3254-00-203-0200-68`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/03-3254-00-203-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4756-00-203-0200-68`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/02-4756-00-203-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0672-00-203-0200-68`}>
                            <img className={`fish fish__five`}
                                 src={`/storage/img/collections/ocean/mobile/05-0672-00-203-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__five`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-10.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-11.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__three`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-12.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__four`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-13.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            Медузы... Их&nbsp;повадки поражают воображение. Их&nbsp;грациозная расцветка
                            очаровывает. Их&nbsp;удлинённые серебряные силуэты в&nbsp;сочетании с&nbsp;блеском
                            аметистов дарят настоящий восторг!
                        </p>
                        <Link href={`/catalog/product/03-3252-00-203-0200-69`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/03-3252-00-203-0200-69_new.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4754-00-203-0200-69`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/02-4754-00-203-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/04-0255-00-203-0200-69`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/04-0255-00-203-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0671-00-203-0200-69`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/05-0671-00-203-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__six`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-14.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-15.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__three`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-16.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__four`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-17.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            Трогательный символ верности и&nbsp;романтики. Юркие морские коньки выбирают
                            спутника
                            на&nbsp;всю жизнь, и&nbsp;это так трогательно! Их&nbsp;серебряные силуэты найдут
                            местечко в&nbsp;вашем сердце.
                        </p>
                        <Link href={`/catalog/product/02-4755-00-203-0200-69`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/02-4755-00-203-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4786-00-203-0200-69`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/02-4786-00-203-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/04-0256-00-203-0200-69`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/04-0256-00-203-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/03-3253-00-203-0200-69`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/03-3253-00-203-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__seven`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-18.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-19.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__three`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-20.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            Осьминог&nbsp;&mdash; символ морской пучины, из&nbsp;которой был сотворён весь мир.
                            В&nbsp;созвучии с&nbsp;голубым топазом его образ олицетворяет гармонию
                            и&nbsp;воплощение самых смелых идей.
                        </p>
                        <Link href={`/catalog/product/02-4766-00-201-0200-69`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/02-4766-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/01-5487-00-201-0200-69`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/01-5487-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/07-0245-00-201-0200-69`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/07-0245-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/03-3257-00-201-0200-69`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/03-3257-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0685-00-201-0200-69`}>
                            <img className={`fish fish__five`}
                                 src={`/storage/img/collections/ocean/mobile/05-0685-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__eight`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-21.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-22.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__three`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-23.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            Грациозные скаты ассоциируются с&nbsp;беззаботной жизнью и&nbsp;отдыхом. Их&nbsp;изящный
                            подводный полёт нашёл своё отражение в&nbsp;серебряных силуэтах наших украшений.
                        </p>
                        <Link href={`/catalog/product/02-4765-00-000-0200-68`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/02-4765-00-000-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/03-3256-00-000-0200-68`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/03-3256-00-000-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/01-5480-00-000-0200-68`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/01-5480-00-000-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0676-00-000-0200-68`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/05-0676-00-000-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__nine`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-24.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-25.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__three`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-26.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            Неторопливые и&nbsp;плавные, изящные и&nbsp;грациозные... Элегантные серебряные
                            рыбки
                            с&nbsp;крупными голубыми топазами огранки триллион. Обольстительные украшения
                            с&nbsp;лёгким характером.
                        </p>
                        <Link href={`/catalog/product/04-0258-00-201-0200-69`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/04-0258-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/03-3261-00-201-0200-69`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/03-3261-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4770-00-201-0200-69`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/02-4770-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0678-00-201-0200-69`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/05-0678-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__ten`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-27.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-28.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            Изящные хищницы в&nbsp;красно-фиолетовых тонах! Медузы&nbsp;&mdash; опасные
                            красавицы, движения которых восхищают и&nbsp;завораживают. Не&nbsp;стоит недооценивать
                            их&nbsp;потенциал. Они умеют за&nbsp;себя постоять!
                        </p>
                        <Link href={`/catalog/product/02-4777-00-000-0200-69`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/02-4777-00-000-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4787-00-000-0200-69`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/02-4787-00-000-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/03-3262-00-000-0200-69`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/03-3262-00-000-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0686-00-000-0200-69`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/05-0686-00-000-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__eleven`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-29.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-30.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            Эффектный силуэт морских скатов и&nbsp;чувственная глубина голубого
                            топаза&nbsp;&mdash; идеальная метафора для &laquo;подводных&raquo; украшений.
                            С&nbsp;ними вы&nbsp;почувствуете настоящий восторг новых открытий!
                        </p>
                        <Link href={`/catalog/product/03-3258-00-201-0200-69`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/03-3258-00-201-0200-69_new.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/01-5481-00-201-0200-69`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/01-5481-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4767-00-201-0200-69`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/02-4767-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0684-00-201-0200-69`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/05-0684-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__twelve`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-32.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-33.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__three`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-34.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__four`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-35.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            Наши драгоценные рыбки&nbsp;&mdash; спутники вашей удачи. Их&nbsp;плавные силуэты,
                            украшенные эмалью и&nbsp;white-топазами, привнесут в&nbsp;образ лёгкую игривость
                            и&nbsp;чувство гармонии.
                        </p>
                        <Link href={`/catalog/product/02-4750-00-201-0200-69`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/02-4750-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4749-00-201-0200-69`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/02-4749-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/03-3250-00-201-0200-69`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/03-3250-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/05-0669-00-201-0200-69`}>
                            <img className={`fish fish__four`}
                                 src={`/storage/img/collections/ocean/mobile/05-0669-00-201-0200-69.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__thirteen`}>
                    <div className={`contentMobile`}>
                        <img className={`fauna fauna__one`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-36.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <img className={`fauna fauna__two`}
                             src={`/storage/img/collections/ocean/mobile/FAUNA-37.png`}
                             alt={`fauna`}
                             title={`fauna`}
                        />
                        <p className={`text`}>
                            Житель глубин океана&nbsp;&mdash; осьминог. Ему приписываются такие качества, как
                            сила, долголетие и&nbsp;даже вечная жизнь. В&nbsp;голубых оттенках эмали
                            он&nbsp;просто олицетворение элегантности!
                        </p>
                        <Link href={`/catalog/product/03-3259-00-000-0200-68`}>
                            <img className={`fish fish__one`}
                                 src={`/storage/img/collections/ocean/mobile/03-3259-00-000-0200-68_new.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/02-4768-00-000-0200-68`}>
                            <img className={`fish fish__two`}
                                 src={`/storage/img/collections/ocean/mobile/02-4768-00-000-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                        <Link href={`/catalog/product/01-5486-00-000-0200-68`}>
                            <img className={`fish fish__three`}
                                 src={`/storage/img/collections/ocean/mobile/01-5486-00-000-0200-68.png`}
                                 alt={`fish`}
                                 title={`fish`}
                            />
                        </Link>
                    </div>
                </div>

                <div className={`oceanPanelMobile__fourteen`}>
                    <div className={`contentMobile`}>
                        <p className={`textTop`}>Сокровища</p>
                        <p className={`textBottom`}>Океана</p>
                        <Link href={`/catalog/okean`}
                              className={`inCatalog`}
                        >
                            Перейти в каталог&nbsp;&nbsp;&nbsp;
                            <img className={`arrow-bottom`}
                                 src={`/storage/img/collections/ocean/mobile/arrow-end.png`}
                                 alt={`Каталог ювелирных украшений`}
                                 title={`Каталог ювелирных украшений`}
                            />
                        </Link>
                    </div>
                </div>
            </div>
        </>
    }
}

export default useWithStore(OceanMobile);
